import { PRESETS } from "../data/studio";
import { Sparkles } from "lucide-react";

export function PresetChips({ activeId, onSelect }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-amber-300" />
        <span className="font-label text-amber-400/90">Start from a preset</span>
      </div>
      <div className="flex gap-2.5 overflow-x-auto pb-2 -mx-1 px-1 snap-x scrollbar-thin">
        <button
          data-testid="preset-chip-custom"
          onClick={() => onSelect(null)}
          className={`snap-start shrink-0 min-w-[130px] text-left rounded-xl border px-3.5 py-3 transition-all ${
            activeId === null
              ? "border-amber-400 bg-amber-400/10 shadow-[0_0_16px_rgba(212,175,55,0.25)]"
              : "border-[#1E2C48] bg-[#0D1424] hover:border-amber-400/40"
          }`}
        >
          <div className="text-sm font-semibold text-slate-100">Custom Song</div>
          <div className="text-[11px] text-slate-400 mt-0.5">Blank studio</div>
        </button>
        {PRESETS.map((p) => (
          <button
            key={p.id}
            data-testid={`preset-chip-${p.id}`}
            onClick={() => onSelect(p)}
            className={`snap-start shrink-0 min-w-[160px] text-left rounded-xl border px-3.5 py-3 transition-all ${
              activeId === p.id
                ? "border-amber-400 bg-amber-400/10 shadow-[0_0_16px_rgba(212,175,55,0.25)]"
                : "border-[#1E2C48] bg-[#0D1424] hover:border-amber-400/40"
            }`}
          >
            <div className="text-sm font-semibold text-slate-100 whitespace-nowrap">{p.name}</div>
            <div className="text-[11px] text-slate-400 mt-0.5 whitespace-nowrap">{p.subtitle}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
